import {forwardRef} from 'react';

import {LinkProps} from './Link.types';

import {linkStyles} from './Link.css';

/**
 * Links allow users to take actions, and make choices, with a single tap.
 *
 * When a `ref` prop is provided, it will be forwarded to the root element. Any
 * other properties supplied will be provided to the root element.
 * This includes all appropriate HTML attributes or aria tags.
 */
export const Link = forwardRef(
  <T extends React.ElementType = 'a'>(
    {as, className, href, onClick, disabled, variant, ...otherProps}: LinkProps<T>,
    ref?: PolymorphicRef<T>,
  ) => {
    const Component = as || 'a';

    return (
      <Component
        ref={ref}
        className={`${linkStyles({disabled, variant})} ${className}`}
        href={disabled ? undefined : href}
        onClick={disabled ? undefined : onClick}
        disabled={disabled}
        {...otherProps}
      />
    );
  },
);
